function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Mikal Morello Logo");

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "accent",
  d: "M53.4,40.9l2.7,5.7l-26.3,35c-0.2,0.3-2.1,2.5-3.7,7.6c-1.4,4.5-2.1,11.6-3.9,13.6 c-5.8,6.4-12.6,1.1-12.7-4.4c0-1.8,0.8-5.8,3-9.4c2.7-4.5,6.8-8.8,7-8.9l6.1-6.5L53.4,40.9z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "el_1DbigiG7Y1"
}, React.createElement("rect", {
  id: "el_RiVzeUJspf",
  x: 9.1,
  width: 325.7,
  height: 109.2
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "el_FIjhLVy876_an_nVjnwZTK8",
  "data-animator-group": "true",
  "data-animator-type": 0
}, React.createElement("rect", {
  id: "el_FIjhLVy876",
  width: 343.8,
  height: 109.2
}));

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "mains",
  d: "M331.1,47l-2.1,7.5c-1.3,4.4-2.7,8.4-4.3,11.9c-1.3,3.1-2.7,6-4.2,8.6c-1.5,2.6-2.9,4.1-4.4,4.4h-0.4 c-2.4-0.1-4.7-2.6-6.9-7.3c-2.2-4.8-4.4-10.5-6.7-17.4c-1.7-5.5-3.4-11.3-5.1-17.3c-1.7-6-3.6-11.5-5.5-16.7 c-2-5.2-4.2-9.6-6.5-13.3c-2.3-3.7-4.9-5.9-7.8-6.6c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.6-0.1-0.9-0.1h-0.2c-0.4,0-0.7,0-1.1,0.1 c-2.4,0.1-4.7,1.5-6.8,4.1c-2.2,2.8-4.2,6.4-6.1,10.9c-1.8,4.5-3.6,9.5-5.2,15c-1.6,5.5-3.2,11-4.8,16.4l-2.1,7.5 c-1.3,4.4-2.7,8.4-4.3,11.9c-1.3,3.1-2.7,6-4.2,8.6c-1.5,2.6-2.9,4.1-4.4,4.4H236c-2.4-0.1-4.7-2.6-6.9-7.3 c-2.2-4.8-4.4-10.5-6.7-17.4c-1.7-5.5-3.4-11.3-5.1-17.3c-1.7-6-3.6-11.5-5.5-16.7c-2-5.2-4.2-9.6-6.5-13.3 c-2.3-3.7-4.9-5.9-7.8-6.6c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.6-0.1-0.9-0.1h-0.2c-2.7,0-5.3,2-7.8,5.9c-2.5,3.9-4.9,8.8-7.1,14.6 c-2.3,5.8-4.5,12.1-6.6,19c-2.1,6.8-4.2,13.1-6.2,19c-0.9,2.7-2.2,8.7-4.9,15.3c0,0,0,0,0,0.1c-1.2,2.8-1.8,4.6-3.9,4.7h-0.4 c-2.4-0.1-4.7-2.6-6.9-7.3c-2.2-4.8-4.4-10.5-6.7-17.4c-1.7-5.5-3.4-11.3-5.1-17.3c-1.7-6-3.6-11.5-5.5-16.7 c-2-5.2-4.2-9.6-6.5-13.3c-2.3-3.7-4.9-5.9-7.8-6.6c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.6-0.1-0.9-0.1h-0.2c-2.7,0-5.3,2-7.8,5.9 c-2.5,3.9-4.9,8.8-7.1,14.6c-2.3,5.8-4.5,12.1-6.6,19c-2.1,6.8-4.2,13.1-6.2,19c-2,5.8-3.9,10.7-5.6,14.6 c-1.8,3.9-3.5,5.9-5.2,5.9s-4-1.8-7-5.5c-3-3.7-6.1-8.3-9.4-13.7c-2.5-4.2-4.9-8.6-7.1-13.3c1.8-3.5,3.6-7.2,5.3-10.9 c2.9-6.4,4.8-12.2,5.8-17.5c0.9-5.3,0.5-9.6-1.2-13c-1.7-3.4-5.6-5.1-11.7-5.1c-4.5,0-8.4,0.6-11.6,1.8c-3.2,1.2-5.9,2.8-8.2,4.8 c-2.3,2-4,4.3-5.3,6.8c-1.3,2.6-2.3,5.2-3,7.9c-1.6,6.3-1.9,13.3-1.1,21.1c1.6,12.4,4,23.4,7.2,33c1.4,4.1,3.1,8.1,4.9,12 c1.8,3.9,4,7.4,6.6,10.5c2.6,3.1,5.4,5.6,8.6,7.5c3.2,1.8,6.8,2.8,10.8,2.8c5,0,9.3-1.6,13-4.8c3.7-3.2,6.9-7.2,9.6-12 c2.7-4.8,5-10.1,6.9-15.8c1.9-5.7,3.5-10.9,4.9-15.8c1.3-4.8,2.5-8.8,3.5-12c1-3.2,2-4.8,3-4.8c0.9,0,1.7,1.6,2.6,4.8 s1.8,7.2,2.9,12c1.1,4.8,2.4,10.1,3.9,15.8c1.6,5.7,3.5,10.9,5.9,15.8c2.3,4.8,5.3,8.8,8.7,12c3.5,3.2,7.6,4.8,12.5,4.8h1.5h0.2 h1.9c3.8,0,7.3-1.6,10.5-4.7c3.2-3.1,6.1-7,8.6-11.6c1.2-2.1,2.2-4.4,3.1-6.8c1.3-2.9,2.6-6,3.7-9.2c1.9-5.7,3.5-10.9,4.9-15.8 c1.3-4.8,2.5-8.8,3.5-12c1-3.2,2-4.8,3-4.8c0.9,0,1.7,1.6,2.6,4.8s1.8,7.2,2.9,12c1.1,4.8,2.4,10.1,3.9,15.8 c1.6,5.7,3.5,10.9,5.9,15.8c2.3,4.8,5.3,8.8,8.7,12c3.5,3.2,7.6,4.8,12.5,4.8h1.5h0.2h1.9c3.8,0,7.3-1.6,10.5-4.7 c3.2-3.1,6.1-7,8.6-11.6c2.6-4.6,4.9-9.7,7-15.1c2.1-5.5,4-10.5,5.5-15.1c1.6-4.6,2.9-8.5,4.2-11.6c0.3-0.7,0.6-1.5,0.8-2.3 c0,0,0,0,0,0c0-0.1,0-0.1,0.1-0.2c0.1-0.4,0.2-0.7,0.4-1.1c0.9-2.4,1.7-3.5,2.6-3.5c0.9,0,1.7,1.6,2.6,4.8s1.8,7.2,2.9,12 c1.1,4.8,2.4,10.1,3.9,15.8c1.6,5.7,3.5,10.9,5.9,15.8c2.3,4.8,5.3,8.8,8.7,12c3.5,3.2,7.6,4.8,12.5,4.8h1.5h0.2h1.9 c3.8,0,7.3-1.6,10.5-4.7c3.2-3.1,6.1-7,8.6-11.6c2.6-4.6,4.9-9.7,7-15.1c2.1-5.5,4-10.5,5.5-15.1C334.6,57.4,332.7,41.6,331.1,47 z M46.6,10.6c0.7-3.7,3.1-5.5,7-5.5c4,0,6.5,1.4,7.6,4.2c1.1,2.8,1.1,6.3,0.2,10.7c-0.9,4.3-2.6,9.2-4.9,14.5 c-1,2.2-2,4.4-3.1,6.6c-2.6-5.9-4.6-11.5-5.9-16.6C46.2,18.9,45.8,14.3,46.6,10.6z"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "el_1Ko838t7Wp"
}, React.createElement("rect", {
  id: "el_73rpUx28dF",
  x: 9.1,
  width: 325.7,
  height: 109.2
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "el_BjPPNPPYMS_an_I3azic1YQ",
  "data-animator-group": "true",
  "data-animator-type": 0
}, React.createElement("rect", {
  id: "el_BjPPNPPYMS",
  x: 9.1,
  y: 0,
  width: 325.7,
  height: 109.2
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "el_EG_L-xfsQ",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 343 109",
    style: {
      "enableBackground": "new 0 0 343.8 109.2"
    },
    xmlSpace: "preserve"
  }, props), _ref, React.createElement("g", {
    id: "el_EBF_DusqDD"
  }, React.createElement("g", {
    id: "el_LEX7Ce3qmw"
  }, _ref2, React.createElement("clipPath", {
    id: "accent_1_"
  }, React.createElement("use", {
    xlinkHref: "#accent",
    style: {
      "overflow": "visible"
    }
  })), _ref3, React.createElement("g", {
    id: "el_eDBw9T6cG8"
  }, React.createElement("linearGradient", {
    id: "background_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 54.6138,
    x2: 343.8213,
    y2: 54.6138
  }, React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#EC6E66"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#F3A183"
    }
  })), _ref4))), React.createElement("g", {
    id: "el_48PPAv7E_6"
  }, React.createElement("g", {
    id: "el_R2y2-foFri"
  }, _ref5, React.createElement("clipPath", {
    id: "main_1_"
  }, React.createElement("use", {
    xlinkHref: "#mains",
    style: {
      "overflow": "visible"
    }
  })), _ref6, React.createElement("g", {
    id: "el_1iFGezowkW"
  }, React.createElement("linearGradient", {
    id: "background_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.0806,
    y1: 54.614,
    x2: 334.7398,
    y2: 54.614
  }, React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#EC6E66"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#F3A183"
    }
  })), _ref7))));
};

export default __webpack_public_path__ + "static/media/logo.0e6234bd.svg";
export { SvgComponent as ReactComponent };